import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en-US/translation.json';
import zhTWTranslation from './locales/zh-TW/translation.json';
import viVNTranslation from './locales/vi-VN/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': {
        translation: enTranslation
      },
      'zh-TW': {
        translation: zhTWTranslation
      },
      'vi-VN': {
        translation: viVNTranslation
      }
    },
    fallbackLng: 'zh-TW',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 